import { z } from "zod";

export const GetRequestTypesWithTagsInputSchema = z.object({
    userName: z.string().nullish(),
    searchQuery: z.string().nullish(),
    parentTagId: z.string().nullish(),
    id: z.number().nullish(),
});

export type GetRequestTypesWithTagsInput = z.infer<typeof GetRequestTypesWithTagsInputSchema>;